var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import "react-ladda-button/dist/ladda-themeless.min.css";
import { ErrorMessage, Field, Form, Formik } from "formik";
import LaddaButton, { ZOOM_IN } from "react-ladda-button";
import React, { useEffect, useRef, useState } from "react";
import { hidePageLoader, showPageLoader } from "../../components/pageLoader/pageLoader";
import CheckoutIcon from "./CheckoutIcon";
import { ConnectedFocusError } from "focus-formik-error";
import DropIn from "braintree-web-drop-in-react";
import FormErrorNotification from "./FormErrorNotification";
import PulseLoader from "react-spinners/PulseLoader";
import RadioInput from "./RadioInput";
import ReactDOM from "react-dom/client";
import { ReactSVG } from "react-svg";
import SlideDown from "react-slidedown";
import Swal from "sweetalert2";
import { USD } from "../../utils/helpers";
import { checkoutSchema } from "./checkoutSchema";
import classNames from "classnames";
const DEFAULT_COUNTRY_ID = "237"; //United States
const DEFAULT_STATE_ID = "6"; //California
const showErrMsg = (text) => Swal.fire({ title: "Checkout", text: text, icon: "error" });
const SameAddressComponent = ({ name }) => (React.createElement("div", { className: "row my-4 justify-content-center" },
    React.createElement("div", { className: "col-md-6" },
        React.createElement("label", { className: "form-check-label", htmlFor: name },
            React.createElement(Field, { type: "checkbox", name: "same_addresses", id: name, className: "form-check-input" }),
            React.createElement("span", { className: "custom-check-text ps-2" }, "My billing address and shipping address are the same")))));
const AddressList = ({ name, addressList, errors, touched }) => (React.createElement("div", { className: "checkout-billing-address", role: "group" },
    React.createElement("p", null,
        "Select your ",
        name,
        " address"),
    addressList.map(add => (React.createElement(RadioInput, { key: add.id, name: `${name}_address_id`, value: `${add.id}`, errors: errors, touched: touched },
        add.first_name,
        " ",
        add.last_name,
        React.createElement("br", null),
        add.address1,
        React.createElement("br", null),
        add.state_name && React.createElement(React.Fragment, null,
            add.state_name,
            React.createElement("br", null)),
        add.postcode,
        React.createElement("br", null),
        add.country_name !== "United States of America" && React.createElement(React.Fragment, null,
            add.country_name,
            React.createElement("br", null))))),
    React.createElement(SlideDown, { closed: !errors[`${name}_address_id`] },
        React.createElement("div", { className: "alert-text text-danger" },
            React.createElement(ErrorMessage, { name: `${name}_address_id` }))),
    React.createElement(RadioInput, { name: `${name}_address_id`, value: "-1" }, "Enter new address")));
const Checkout = (props) => {
    var _a, _b, _c;
    const form = useRef(null);
    const [isLoading, setLoading] = useState(true);
    const [getOrder, setOrder] = useState();
    const [addressList, setAddresses] = useState([]);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [isSubmitting, setSubmitting] = useState(false);
    //Timer to invalidate checkout (20 mins)
    //Braintree variables
    const [clientToken, setClientToken] = useState("");
    let brainTreeInstance;
    //Load data when loaded
    useEffect(() => {
        loadData();
    }, []);
    //Load all the data
    const loadData = () => __awaiter(void 0, void 0, void 0, function* () {
        yield Promise.all([
            //Grab the pending order information 
            loadRemoteData(`/ajax/getPendingOrderDetails`, ["order", "addresses", "klaviyo"]),
            //Grab the country information
            loadRemoteData(`/ajax/getCountries`, ["countries"]),
            //Grab the state information
            loadRemoteData(`/ajax/getStates`, ["states"]),
            //Get Braintree token
            loadRemoteData(`/services/braintree/generate-client-token.php?bid=${props.brainTreeId}`, ["token"])
        ]);
        setTimeout(() => {
            setLoading(false);
            //timer.start()
        }, 0);
    });
    //Load remote data and updates the states 'stateVar' value
    const loadRemoteData = (url, stateVar) => __awaiter(void 0, void 0, void 0, function* () {
        yield fetch(url)
            .then(resp => {
            if (resp.ok)
                return resp.json();
        }).then((data) => {
            for (const state of stateVar) {
                switch (state) {
                    case "order":
                        setOrder(data.order);
                        break;
                    case "addresses":
                        setAddresses(data.addresses);
                        break;
                    case "klaviyo":
                        //@ts-ignore: klaviyo is a global object
                        klaviyo.push(["track", "Started Checkout", data.klaviyo]);
                        console.log("Klaviyo: Started Checkout");
                        break;
                    case "countries":
                        setCountries(data);
                        break;
                    case "states":
                        setStates(data);
                        break;
                    case "token":
                        setClientToken(data.result);
                        break;
                }
            }
        });
    });
    const renderLoading = () => {
        const colour = "#000";
        return (React.createElement("div", { style: {
                margin: "0 auto",
                textAlign: "center",
            } },
            React.createElement(PulseLoader, { color: colour, loading: true, speedMultiplier: 0.8, cssOverride: {
                    margin: "0 auto",
                    marginTop: "10%",
                    marginBottom: "20px",
                } })));
    };
    const renderTextInput = (fieldName, label, errors, touched, additional) => {
        const inputClasses = classNames("form-control", {
            "is-invalid": errors[fieldName] && touched[fieldName]
        });
        return (React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: fieldName }, label),
            React.createElement(Field, { name: fieldName, id: fieldName, className: inputClasses }),
            React.createElement("div", { className: "is-invalid invalid-feedback" },
                React.createElement(ErrorMessage, { name: fieldName })),
            additional && additional.helpText));
    };
    const defaultBillingAddress = () => {
        return addressList.find(a => a.is_default_billing) || addressList[0];
    };
    const defaultShippingAddress = () => {
        return addressList.find(a => a.is_default_shipping) || addressList[0];
    };
    if (isLoading)
        return renderLoading();
    if (!getOrder)
        return renderLoading();
    const billing_address_id = typeof ((_a = defaultBillingAddress()) === null || _a === void 0 ? void 0 : _a.id) == "undefined" ? "-1" : `${defaultBillingAddress().id}`;
    const shipping_address_id = typeof ((_b = defaultShippingAddress()) === null || _b === void 0 ? void 0 : _b.id) == "undefined" ? "-1" : `${defaultShippingAddress().id}`;
    const same_addresses = getOrder.collection
        ? true
        : (defaultBillingAddress === defaultShippingAddress) || typeof ((_c = defaultShippingAddress()) === null || _c === void 0 ? void 0 : _c.id) == "undefined";
    return (React.createElement(React.Fragment, null,
        React.createElement(Formik, { initialValues: {
                billing_firstname: "",
                billing_lastname: "",
                billing_address1: "",
                billing_address2: "",
                billing_city: "",
                billing_country: DEFAULT_COUNTRY_ID,
                billing_state: DEFAULT_STATE_ID,
                billing_postcode: "",
                billing_phone: "",
                billing_delivery: "",
                same_addresses: same_addresses,
                shipping_firstname: "",
                shipping_lastname: "",
                shipping_address1: "",
                shipping_address2: "",
                shipping_city: "",
                shipping_country: DEFAULT_COUNTRY_ID,
                shipping_state: DEFAULT_STATE_ID,
                shipping_postcode: "",
                shipping_phone: "",
                //Pre-selected address details
                billing_address_id: billing_address_id,
                shipping_address_id: shipping_address_id,
                isCollection: (getOrder === null || getOrder === void 0 ? void 0 : getOrder.collection) || false,
                nonce: "",
                deviceData: "",
                addressList: addressList
            }, validationSchema: checkoutSchema, onSubmit: values => {
                setSubmitting(true);
                showPageLoader(`Processing payment. Please wait...`, `This can take up to 30 seconds during busy periods.<br />Please don't leave this page or refresh.`);
                //Attempt Braintree payment  
                brainTreeInstance.requestPaymentMethod().then(payload => {
                    //Inject Braintree details to form
                    form.current.nonce.value = payload.nonce;
                    form.current.deviceData.value = payload.deviceData;
                    //Submit the form
                    setTimeout(() => {
                        form.current.submit();
                    }, 100);
                }).catch(error => {
                    showErrMsg("3D secure verification failed. Your payment didn't go through. Please check the card info and billing address.");
                    setSubmitting(false);
                    hidePageLoader();
                    throw error;
                });
            } }, ({ errors, touched, values, handleChange }) => {
            useEffect(() => {
                if (values.billing_country !== DEFAULT_COUNTRY_ID) {
                    values.billing_state = "";
                }
            }, [values.billing_country]);
            useEffect(() => {
                if (values.shipping_country !== DEFAULT_COUNTRY_ID) {
                    values.shipping_state = "";
                }
            }, [values.shipping_country]);
            return (React.createElement(Form, { ref: form, method: "post" },
                React.createElement("div", { className: "card custom-card checkout-card" },
                    React.createElement("div", { className: "card-header" },
                        React.createElement("h1", { className: "card-title h3" }, "Checkout")),
                    React.createElement("div", { className: "card-body" },
                        React.createElement("div", { className: "text-center" },
                            React.createElement("div", { className: "order-summary-icons" },
                                React.createElement(CheckoutIcon, { icon: getOrder.subscription ? React.createElement(ReactSVG, { src: "/assets/images/checkout-icons/subscription.svg" }) : React.createElement(ReactSVG, { src: "/assets/images/checkout-icons/single.svg" }), text: getOrder.subscription ? "Subscription" : "Single Order" }),
                                React.createElement(CheckoutIcon, { icon: getOrder.collection ? React.createElement(ReactSVG, { src: "/assets/images/checkout-icons/pickup.svg" }) : React.createElement(ReactSVG, { src: "/assets/images/checkout-icons/delivery.svg" }), text: getOrder.collection ? "For pickup" : "For delivery" }),
                                React.createElement(CheckoutIcon, { icon: React.createElement(ReactSVG, { src: "/assets/images/checkout-icons/total.svg" }), text: USD(getOrder.total).format() }))),
                        React.createElement("fieldset", null,
                            React.createElement("legend", null, "Billing address"),
                            addressList.length > 0 && React.createElement(AddressList, { name: "billing", addressList: addressList, errors: errors, touched: touched }),
                            React.createElement(SlideDown, { closed: values.billing_address_id !== "-1" },
                                React.createElement("div", null,
                                    React.createElement("div", { className: "row mt-4" },
                                        React.createElement("div", { className: "col-sm" }, renderTextInput("billing_firstname", "First name", errors, touched)),
                                        React.createElement("div", { className: "col-sm" }, renderTextInput("billing_lastname", "Last name", errors, touched))),
                                    renderTextInput("billing_address1", "Address 1", errors, touched),
                                    renderTextInput("billing_address2", "Address 2", errors, touched),
                                    renderTextInput("billing_city", "City", errors, touched),
                                    React.createElement("div", { className: "row" },
                                        React.createElement("div", { className: "col-sm" },
                                            React.createElement("div", { className: "form-group" },
                                                React.createElement("label", { htmlFor: "billing_country" }, "Country"),
                                                React.createElement(Field, { as: "select", name: "billing_country", id: "billing_country", className: "form-control" }, countries.map(country => (React.createElement("option", { key: country.id, value: country.id }, country.name)))))),
                                        values.billing_country === DEFAULT_COUNTRY_ID && (React.createElement("div", { className: "col-sm" },
                                            React.createElement("div", { className: "form-group" },
                                                React.createElement("label", { htmlFor: "billing_state" }, "State"),
                                                React.createElement(Field, { as: "select", name: "billing_state", id: "billing_state", className: "form-control" }, states.map(state => (React.createElement("option", { key: state.id, value: state.id }, state.name))))))),
                                        React.createElement("div", { className: "col-sm" }, renderTextInput("billing_postcode", "Zip code", errors, touched))),
                                    renderTextInput("billing_phone", "Phone number", errors, touched, { helpText: React.createElement("div", { className: "form-text" }, "Your phone number will not be used for marketing purposes, and only used to notify you about your delivery") }),
                                    renderTextInput("billing_delivery", "Delivery instructions", errors, touched, { helpText: React.createElement("div", { className: "form-text" }, "For delivery use: If you're not in, please tell us how to handle your delivery") }))),
                            !getOrder.collection && React.createElement(SameAddressComponent, { name: "same_addresses2" }),
                            getOrder.collection ? React.createElement(Field, { type: "hidden", name: "same_address", id: "same_address", value: "1" }) : ""),
                        React.createElement(SlideDown, { closed: values.same_addresses },
                            React.createElement("fieldset", null,
                                React.createElement("legend", null, "Shipping address"),
                                addressList.length > 0 && React.createElement(AddressList, { name: "shipping", addressList: addressList, errors: errors, touched: touched }),
                                React.createElement(SlideDown, { closed: values.shipping_address_id !== "-1" },
                                    React.createElement("div", { className: "row mt-4" },
                                        React.createElement("div", { className: "col-sm" }, renderTextInput("shipping_firstname", "First name", errors, touched)),
                                        React.createElement("div", { className: "col-sm" }, renderTextInput("shipping_lastname", "Last name", errors, touched))),
                                    renderTextInput("shipping_address1", "Address 1", errors, touched),
                                    renderTextInput("shipping_address2", "Address 2", errors, touched),
                                    renderTextInput("shipping_city", "City", errors, touched),
                                    React.createElement("div", { className: "row" },
                                        React.createElement("div", { className: "col-sm" },
                                            React.createElement("div", { className: "form-group" },
                                                React.createElement("label", { htmlFor: "shipping_country" }, "Country"),
                                                React.createElement(Field, { as: "select", name: "shipping_country", id: "shipping_country", className: "form-control" }, countries.map(country => (React.createElement("option", { key: country.id, value: country.id }, country.name)))))),
                                        values.shipping_country === DEFAULT_COUNTRY_ID && (React.createElement("div", { className: "col-sm" },
                                            React.createElement("div", { className: "form-group" },
                                                React.createElement("label", { htmlFor: "shipping_state" }, "State"),
                                                React.createElement(Field, { as: "select", name: "shipping_state", id: "billing_state", className: "form-control" }, states.map(state => (React.createElement("option", { key: state.id, value: state.id }, state.name))))))),
                                        React.createElement("div", { className: "col-sm" }, renderTextInput("shipping_postcode", "Zip code", errors, touched))),
                                    renderTextInput("shipping_phone", "Phone number", errors, touched, { helpText: React.createElement("div", { className: "form-text" }, "Your phone number will not be used for marketing purposes, and only used to notify you about your order") })))),
                        React.createElement("fieldset", null,
                            React.createElement("legend", null, "Payment options"),
                            React.createElement(DropIn, { options: {
                                    authorization: clientToken,
                                    vaultManager: true,
                                    card: {
                                        vault: {
                                            allowVaultCardOverride: true
                                        }
                                    }
                                }, onInstance: instance => brainTreeInstance = instance }))),
                    React.createElement("div", { className: "card-footer split-btn-row" },
                        React.createElement(LaddaButton, { type: "submit", "data-style": ZOOM_IN, loading: isSubmitting, className: "btn btn-cta btn-lg btn-end" }, "Pay now"))),
                React.createElement(Field, { type: "hidden", name: "nonce", id: "nonce", value: "" }),
                React.createElement(Field, { type: "hidden", name: "deviceData", id: "deviceData", value: "" }),
                React.createElement(Field, { type: "hidden", name: "_token", id: "_token", value: props.token }),
                React.createElement(ConnectedFocusError, null),
                React.createElement(FormErrorNotification, null)));
        })));
};
const checkoutFormHolder = document.querySelector("#checkout-form-holder");
if (checkoutFormHolder) {
    const planSetupRoot = ReactDOM.createRoot(checkoutFormHolder);
    const token = checkoutFormHolder.dataset.token;
    const brainTreeId = checkoutFormHolder.dataset.bid;
    planSetupRoot.render(React.createElement(Checkout, { token: token, brainTreeId: brainTreeId }));
}
